<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-xl-3 col-md-3">
                <router-link :to="{name: 'offer_step1'}" class="btn btn-block btn-success m-b-20">
                    <i class="fas fa-hand-holding-usd m-r-10"></i> Post a New Offer
                </router-link>

                <div class="card">
                    <div class="list-group">
                        <a :class="{'active': showAll}" @click="getAllOffers(1)" class="list-group-item"
                           href="javascript:void(0)"><i class="ti-layers m-r-10"></i> All Offers</a>
                        <a :class="{'active': showFav}" @click="getFavoriteOffers(1)" class="list-group-item"
                           href="javascript:void(0)"><i class="ti-star m-r-10"></i> Your Favourites</a>
                        <a :class="{'active': showRecent}" @click="getRecentOffers(1)" class="list-group-item"
                           href="javascript:void(0)"><i class="ti-bookmark m-r-10"></i> Recently Created</a>
                    </div>
                </div>

                <div class="card">
                    <div class="border-bottom p-15">
                        <h4>Filters </h4>
                    </div>
                    <div class="border-bottom p-15">
                        <div class="card-body">
                            <h5 class="card-title">Organization</h5>
                            <div class="form-check" v-for="(org, index) in facets.orgs">
                                <input @change="searchFacets(1)" class="form-check-input" type="checkbox"
                                       v-bind:id="org.name" v-bind:value="org.id" v-model="search.org_ids">
                                <label class="form-check-label" v-bind:for="org.name">{{org.name}} &nbsp;
                                    ({{org.count}})</label>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom p-15">
                        <div class="card-body">
                            <h5 class="card-title">Crops</h5>
                            <div class="form-check" v-for="(u, index) in facets.crops">
                                <input @change="searchFacets(1)" class="form-check-input" type="checkbox"
                                       v-bind:id="u.name" v-bind:value="u.id" v-model="search.crop_ids">
                                <label class="form-check-label" v-bind:for="u.name">{{u.name}} &nbsp;
                                    ({{u.count}})</label>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-bottom p-15">
                        <div class="card-body">
                            <h5 class="card-title">Harvest Year</h5>
                            <div class="form-check" v-for="(u, index) in facets.harvest_years">
                                <input @change="searchFacets(1)" class="form-check-input" type="checkbox"
                                       v-bind:id="u.year" v-bind:value="u.year" v-model="search.harvest_years">
                                <label class="form-check-label" v-bind:for="u.year">{{u.year}} &nbsp;
                                    ({{u.count}})</label>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom p-15">
                        <div class="card-body">
                            <h5 class="card-title">Category</h5>
                            <div class="form-check" v-for="(u, index) in facets.categories">
                                <input @change="searchFacets(1)" class="form-check-input" type="checkbox"
                                       v-bind:id="u.category" v-bind:value="u.category" v-model="search.categories">
                                <label class="form-check-label" v-bind:for="u.category">{{u.category | capitalize}}
                                    &nbsp; ({{u.count}})</label>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-bottom p-15">
                        <div class="card-body">
                            <h5 class="card-title">Country</h5>
                            <div class="form-check" v-for="(u, index) in facets.countries">
                                <input @change="searchFacets(1)" class="form-check-input" type="checkbox"
                                       v-bind:id="u.name" v-bind:value="u.id" v-model="search.address_ids">
                                <label class="form-check-label" v-bind:for="u.name">{{u.name}} &nbsp;
                                    ({{u.count}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-xl-9 col-md-9">
                <div class="row">
                    <div class="col-9">
                        <ul class="select2-selection__rendered custom-flex">
                            <li :id="u" class="selection-choice2" data-select2-id="346" title="blue"
                                v-for="(u, index) in search.crop_ids">
                                {{cropName(u)}}<span @click="removeCrop(u)" class="select-remove"> ×</span>
                            </li>
                            <li class="selection-choice2" data-select2-id="346" title="blue"
                                v-for="(u, index) in search.harvest_years">
                                {{u}}<span @click="removeHyear(u)" class="select-remove"> ×</span>
                            </li>
                            <li class="selection-choice2" data-select2-id="346" title="blue"
                                v-for="(u, index) in search.categories">
                                {{u | capitalize}}<span @click="removeCategory(u)" class="select-remove"> ×</span>
                            </li>
                            <li class="selection-choice2" data-select2-id="346" title="blue"
                                v-for="(u, index) in search.address_ids">
                                {{getCountry(u)}}<span @click="removeCountry(u)" class="select-remove"> ×</span>
                            </li>
                            <li class="selection-choice2" data-select2-id="346" title="blue"
                                v-for="(org, index) in search.org_ids">
                                {{orgName(org)}}<span @click="removeOrg(org)" class="select-remove"> ×</span>
                            </li>
                            <li @click="removeAllFilter()" class="remove-all" v-if="isFilter()"><u>Clear all</u></li>
                        </ul>
                    </div>
                    <div class="col-3 text-right  m-b-30">
                        <span aria-expanded="false" aria-haspopup="true" style="font-weight: bold;font-size: 15px"
                              v-if="offers.length !== 0">Showing {{offers.length}} of {{total}} items</span>
                    </div>
                </div>

                <div class="alert alert-info" v-if="partner_invitation">
                    <h3 class="text-info"><i class="fa fa-exclamation-circle"></i> Invitation to be partner</h3> <b>{{partner_invitation.name}}</b>
                    admin wants to add you as a partner so that you can see offer and open trade with <b>{{partner_invitation.name}}</b>.
                    <div class="button-group text-right mt-3">
                        <button @click="acceptInvitation()" class="btn waves-effect waves-light btn-outline-success"
                                type="button">Accept
                        </button>
                        <button @click="rejectInvitation()" class="btn waves-effect waves-light btn-outline-danger"
                                type="button">Reject
                        </button>
                    </div>
                </div>
                <div class="card" v-bind:key="index" v-for="(offer,index) in offers" v-if="offers.length > 0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="font-bold m-b-xs">{{offer.commodity_name}}</h3>
                                <div>{{offer.name}}</div>
                              <div>Created By <strong>{{offer.first_name}} {{offer.last_name}}</strong></div>
                                <hr>
                                <div>
                                    <router-link :id="'trade'+index"
                                                 :to="{name: 'viewoffer', params: {offerid: offer.offer_id}}"
                                                 class="btn btn-stem text-white float-right">
                                        <i class="fas fa-handshake"></i>&nbsp;&nbsp;Trade
                                    </router-link>
                                    <h4 class="product-main-price">{{offer.quantity | count}} {{offer.unit.symbol}} <i
                                            class="fas fa-at"></i> {{offer.unit_price | money}}</h4>
                                </div>
                                <div class="">
                                    <br>
                                    {{offer.description}}
                                </div>
                                <dl class="row m-t-md">
                                    <dt class="col-md-4 text-right">Contract Type</dt>
                                    <dd class="col-md-8">{{offer.contract_type | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Offer Type</dt>
                                    <dd class="col-md-8">{{offer.type | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Offer Category</dt>
                                    <dd class="col-md-8">{{offer.category | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Quantity</dt>
                                    <dd class="col-md-8">{{offer.quantity | count}} {{offer.unit.symbol}}</dd>
                                    <dt class="col-md-4 text-right">Unit Price</dt>
                                    <dd class="col-md-8">{{(offer.unit_price) | money}}</dd>
                                    <dt class="col-md-4 text-right" v-if="offer.commodity_props">Grade</dt>
                                    <dd class="col-md-8" v-if="offer.commodity_props">
                                        {{offer.commodity_props['grade']}}
                                    </dd>
                                    <dt class="col-md-4 text-right">Speciality</dt>
                                    <dd class="col-md-8">{{offer.offer_props['commodity_speciality'].join(', ')}}</dd>
                                    <dt class="col-md-4 text-right">Harvest Year</dt>
                                    <dd class="col-md-8">{{offer.harvest_year}}</dd>
                                    <dt class="col-md-4 text-right">Created on</dt>
                                    <dd class="col-md-8">{{offer.created_at | date}}</dd>
                                    <dt class="col-md-4 text-right">Expires on</dt>
                                    <dd class="col-md-8">{{offer.expires_at | date}}</dd>
                                    <dt class="col-md-4 text-right" v-if="offer.contract_type === 'FORWARD'">Maturation
                                        date
                                    </dt>
                                    <dd class="col-md-8" v-if="offer.contract_type === 'FORWARD'">
                                        {{offer.maturation_date | date}}
                                    </dd>
                                    <dt class="col-md-4 text-right">Provenance</dt>
                                    <dd class="col-md-8" v-if="offer.provenance"><a :href="offer.provenance"
                                                                                    target="_blank">{{
                                        offer.provenance }}</a></dd>
                                    <dd class="col-md-8" v-else>NA</dd>
                                    <dt class="col-md-4 text-right">Audit</dt>
                                    <dd class="col-md-8" v-if="offer.audit"><a :href="offer.audit" target="_blank">{{
                                        offer.audit }}</a></dd>
                                    <dd class="col-md-8" v-else>NA</dd>
                                </dl>
                                <div class="text-right">
                                    <div class="btn-group">
                                        <button @click="addToFavorite(offer.offer_id)"
                                                class="btn btn-outline-dark btn-sm" v-if="!offer.fav_offer_id"><i
                                                class="fa fa-heart m-r-5"></i>Add
                                            to
                                            favorites
                                        </button>
                                        <button @click="removeFromFavorite(offer.fav_offer_id)"
                                                class="btn btn-outline-dark btn-sm highlight" v-if="offer.fav_offer_id">
                                            <i
                                                    class="fa fa-times m-r-5"></i>
                                            Remove from favorites
                                        </button>
                                        <router-link :to="{name: 'viewoffer', params: {offerid: offer.offer_id}}"
                                                     class="btn btn-outline-dark btn-sm">
                                            <i class="fa fa-envelope"></i> Contact
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info text-center alert-rounded" v-if="offers.length === 0">
                    <i class="ti-alert"></i> No offers were found. Please wait till creating a new offer by other users.
                </div>
                <div class="row">
                    <div class="col-6" v-if="offers.length !== 0">
                        <span>Page {{pageNumber}} of {{pageCount}}</span>
                    </div>
                    <div class="col-6" v-if="total>3">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'"
                                v-model="pageNumber">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
    import Paginate from 'vuejs-paginate';

    export default {
        name: "AllOffers",
        components: {Paginate},
        data() {
            return {
                showAll: false,
                showFav: false,
                showRecent: false,
                pageCount: 1,
                total: 0,
                pageNumber: 1,
                offers: [],
                filters: {
                    commodity: "",
                    fromDate: "",
                    toDate: "",
                    fromAmount: "",
                    toAmount: "",
                    status: []
                },
                commodities: [],
                facets: {
                    crops: [],
                    harvest_years: [],
                    countries: [],
                    categories: [],
                    orgs: []
                },
                search: {
                    org_ids: [],
                    crop_ids: [],
                    harvest_years: [],
                    address_ids: [],
                    categories: []
                },
                partner_invitation: null
            };
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),
        },
        mounted: function () {
            console.log(this.currentUser)
            this.init();
        },
        methods: {
            async init() {
                await Promise.all([
                    this.getAllOffers(1),
                    this.getFacets(),
                    this.getInvitation()
                ])
            },
            async getInvitation() {
                try {
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/partner/invitation`);
                    this.partner_invitation = data;
                } catch (e) {

                }
            },
            async acceptInvitation() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/members/${this.currentOrg.id}/active`);
                    this.$toastr('success', 'Invitation accepted', 'Accepted');
                    await this.init();
                } catch (e) {

                }
            },
            async rejectInvitation() {
                try {
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/members/${this.currentOrg.id}`);
                    this.$toastr('success', 'Invitation rejected', 'Rejected');
                    await this.init();
                } catch (e) {

                }

            },
            getAllOffers(page) {
                $(".preloader").fadeIn();
                this.search.crop_ids = [];
                this.search.address_ids = [];
                this.search.categories = [];
                this.search.harvest_years = [];
                this.showFav = false;
                this.showRecent = false;
                this.showAll = true;
                this.pageNumber = page;
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers`, {
                        params: {
                            page: page,
                            perPage: 3
                        }
                    })
                    .then(reply => {
                        $(".preloader").fadeOut();
                        this.offers = reply.data.offers;
                        this.total = reply.data.total;
                        this.setPageCount();
                    })
                    .catch(err => {
                        $(".preloader").fadeOut();
                    });
            },
            getRecentOffers(page) {
                this.search.crop_ids = [];
                this.search.address_ids = [];
                this.search.categories = [];
                this.search.harvest_years = [];
                this.showFav = false;
                this.showAll = false;
                this.showRecent = true;
                this.pageNumber = page;
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers`, {
                        params: {
                            page: page,
                            perPage: 3
                        }
                    })
                    .then(reply => {
                        this.offers = reply.data.offers;
                        this.total = reply.data.total;
                        this.setPageCount();
                    })
                    .catch(err => console.error(err));
            },
            pageHandler(pageNum) {
                this.pageNumber = pageNum;
                if (this.showFav) {
                    this.getFavoriteOffers(pageNum);
                } else if (this.showRecent) {
                    this.getRecentOffers(pageNum)
                } else if (this.isFilter()) {
                    this.searchFacets(pageNum);
                } else {
                    this.getAllOffers(pageNum);
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 3 ? 1 : Math.ceil(this.total / 3);
            },
            getFacets() {
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/facets`)
                    .then(reply => {
                        this.facets = reply.data;
                    })
                    .catch(err => console.error(err));
            },
            searchFacets(page) {
                this.showFav = false;
                this.showAll = false;
                this.showRecent = false;
                this.pageNumber = page;
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/${JSON.stringify(this.search)}/search`, {
                        params: {
                            page: page,
                            perPage: 3
                        }
                    })
                    .then(reply => {
                        this.offers = reply.data.offers;
                        this.total = reply.data.total;
                        this.setPageCount();
                    })
                    .catch(err => console.error(err));
            },
            cropName(id) {
                let crop = _.find(this.facets.crops, {id: id});
                return crop.name;
            },
            orgName(id) {
                let org = _.find(this.facets.orgs, {id: id});
                return org.name;
            },
            getCountry(id) {
                let country = _.find(this.facets.countries, {id: id});
                return country.name;
            },
            removeCrop(id) {
                _.remove(this.search.crop_ids, function (n) {
                    return n == id;
                });
                this.search.crop_ids = JSON.parse(JSON.stringify(this.search.crop_ids));
                this.searchFacets(1);
            },
            removeOrg(id) {
                _.remove(this.search.org_ids, function (n) {
                    return n == id;
                });
                this.search.org_ids = JSON.parse(JSON.stringify(this.search.org_ids));
                this.searchFacets(1);
            },
            removeHyear(id) {
                _.remove(this.search.harvest_years, function (n) {
                    return n == id;
                });
                this.search.harvest_years = JSON.parse(JSON.stringify(this.search.harvest_years));
                this.searchFacets(1);
            },
            removeCategory(id) {
                _.remove(this.search.categories, function (n) {
                    return n == id;
                });
                this.search.categories = JSON.parse(JSON.stringify(this.search.categories));
                this.searchFacets(1);
            },
            removeCountry(id) {
                _.remove(this.search.address_ids, function (n) {
                    return n == id;
                });
                this.search.address_ids = JSON.parse(JSON.stringify(this.search.address_ids));
                this.searchFacets(1);
            },
            isFilter() {
                return (this.search.crop_ids.length > 0 || this.search.address_ids.length > 0 || this.search.categories.length > 0 || this.search.harvest_years.length > 0)
            },
            removeAllFilter() {
                this.search.crop_ids = [];
                this.search.address_ids = [];
                this.search.categories = [];
                this.search.harvest_years = [];
                this.getAllOffers(1);
            },
            addToFavorite(offerid) {
                this.$http
                    .put(`/marketplaces/${this.currentOrg.marketplace_id}/offers/favorites`, {
                        offerid: offerid
                    })
                    .then(reply => {
                        if (this.showAll) {
                            this.getAllOffers(this.pageNumber);
                        } else if (this.showRecent) {
                            this.getRecentOffers(this.pageNumber)
                        } else if (this.showFav) {
                            this.getFavoriteOffers(this.pageNumber);
                        } else if (this.isFilter()) {
                            this.searchFacets(this.pageNumber);
                        }
                    })
                    .catch(err => console.error(err));
            },
            removeFromFavorite(favoid) {
                this.$http
                    .delete(`/marketplaces/${this.currentOrg.marketplace_id}/offers/favorites`, {
                        data: {
                            favoid: favoid
                        }
                    })
                    .then(reply => {
                        if (this.showAll) {
                            this.getAllOffers(this.pageNumber);
                        } else if (this.showFav) {
                            this.getFavoriteOffers(1);
                        } else if (this.showRecent) {
                            this.getRecentOffers(this.pageNumber)
                        } else if (this.isFilter()) {
                            this.searchFacets(this.pageNumber);
                        }
                    })
                    .catch(err => console.error(err));
            },
            getFavoriteOffers(page) {
                this.search.crop_ids = [];
                this.search.address_ids = [];
                this.search.categories = [];
                this.search.harvest_years = [];
                this.showRecent = false;
                this.showAll = false;
                this.showFav = true;
                this.pageNumber = page;
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/favorites`, {
                        params: {
                            page: page,
                            perPage: 3
                        }
                    })
                    .then(reply => {
                        this.offers = reply.data.offers;
                        this.total = reply.data.total;
                        this.setPageCount();
                    })
                    .catch(err => console.error(err));
            },
            newOffer() {
                this.$router.push('/offers/new/step1');
            }
        }
    };
</script>

<style scoped>
    .selection-choice2 {
        background-color: #e4e4e4;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        color: #3e5569
    }

    .custom-flex {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0
    }

    .remove-all {
        color: #999;
        cursor: pointer;
        display: inline-block;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        font-weight: bold;
    }

    .remove-all:hover {
        color: #333
    }

    .select-remove {
        color: #999;
        cursor: pointer;
        display: inline-block;
        font-weight: bold;
        margin-right: 1px;
        margin-left: 5px;
    }

    .select-remove:hover {
        color: #333
    }

    .highlight {
        color: #fff;
        background-color: #5a6268;
        border-color: #545b62;
    }
</style>

